// extracted by mini-css-extract-plugin
module.exports = {"root":"CarouselControls_root__Uj9mn","reveal-media":"CarouselControls_reveal-media__Kzkym"};